module.exports = __webpack_public_path__ + "img/PL08343.8c7007b3.png";